import { render, staticRenderFns } from "./AdvisoryDetails.vue?vue&type=template&id=0988f529"
import script from "./AdvisoryDetails.vue?vue&type=script&lang=js"
export * from "./AdvisoryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports